import React, {Component, Fragment} from 'react';

import {ListView} from 'antd-mobile';
import PublicHeader from './../../components/header/index';

class SpaceSearchList extends Component {

    render() {
        return (
            <Fragment>
                <PublicHeader title="场馆预定"/>
                <div>场馆预定</div>
            </Fragment>
        );
    }
}

export default SpaceSearchList;
